import fnc from './commFunction';

// UI routing only. The API verifies the authenticated session and child relationship.
export function isParentAccount() {
  return String(fnc.getCookie('userRole') || '').trim().toLowerCase() === 'parent';
}

export function isTeacherAccount(userInfo = {}) {
  if (isParentAccount()) return false;
  // kind comes from the authenticated hakjuk row: 1 = student, 2 = teacher.
  // A current login takes precedence over any role saved by an older login.
  if (userInfo.id) return String(userInfo.kind || '').trim() === '2';
  return Boolean(fnc.getCookie('appSessionToken'))
    && String(fnc.getCookie('userRole') || '').trim().toLowerCase() === 'teacher';
}

export function isStudentAccount(userInfo = {}) {
  if (isParentAccount()) return false;
  if (userInfo.id) return String(userInfo.kind || '').trim() === '1';
  return Boolean(fnc.getCookie('appSessionToken'))
    && String(fnc.getCookie('userRole') || '').trim().toLowerCase() === 'student';
}
